import React from 'react';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import { getLocaleData } from '@/selectors/localeSelectors';
import { useSelector } from 'react-redux';
import { useSelectedProductFromUserWallet } from '@/hooks/memberHooks';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { cardArtMapping } from '@/constants/productMapping';
import { getCardArtUrl } from '@/helpers/utils';
import { RouteParams } from '@/types';
import InlinePlaceholderMessage from '../common/InlinePlaceholderMessage';
import InlineCardCalloutNotification from '../common/InlineCardCalloutNotification';

type WalletProduct = {
  displayAccountNumber?: string;
  cardArtUrl?: string;
};

const LandingPageCardPicker = () => {
  const { productDisplayNames, selectCard } = useCommonContent();

  const { product } = useRouteParams() as RouteParams;
  const { locale } = useSelector(getLocaleData);
  const baseOneCmsImgUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);

  const productName = productDisplayNames[product]?.cardCallOutDisplayName;

  const urlSpecifiedProductFromUsersWallet = useSelectedProductFromUserWallet(
    product,
    locale
  ) as WalletProduct | null;

  const imgSrc = getCardArtUrl({
    baseOneCmsImgUrl,
    product: cardArtMapping[product as keyof typeof cardArtMapping],
    locale,
  });

  return (
    <>
      <div className="tw-hidden md_tw-block">
        <InlinePlaceholderMessage
          text={selectCard?.inlineMessage}
          placeholder="{inlineCardCallout}"
          className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-3 tw-font-dls tw-text-base tw-font-normal tw-text-gray-800 md_tw-text-base"
          replacement={
            <InlineCardCalloutNotification className="tw-inline-flex tw-font-dls tw-text-base tw-font-medium tw-text-link md_tw-text-base" />
          }
        />
      </div>
      <div className="tw-block tw-flex tw-items-center md_tw-hidden">
        <img
          src={urlSpecifiedProductFromUsersWallet?.cardArtUrl || imgSrc}
          alt={productName ? `${productName}` : 'Card'}
          className="tw-mr-3 tw-h-6 tw-w-9dot5"
        />
        <InlinePlaceholderMessage
          text={selectCard?.inlineMessage}
          placeholder="{inlineCardCallout}"
          className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-font-dls tw-text-xs tw-font-normal tw-text-gray-800"
          replacement={
            <InlineCardCalloutNotification
              hideImage
              className="tw-inline-flex tw-font-dls tw-text-xs tw-font-bold tw-text-link"
            />
          }
        />
      </div>
    </>
  );
};

export default LandingPageCardPicker;
